import type SignalFilters from "../../core/SignalFilters";
import { ECOMMERCE_CHANGE_SUBTYPES } from "../constants";
import type EcommerceSignalFilters from "../EcommerceSignalFilters";
import EcommerceSignalSubType from "../EcommerceSignalSubType";

export const isEcommerceSignalFilters = (
    filters: SignalFilters,
    signalSubType: string | undefined,
): filters is EcommerceSignalFilters => {
    if (typeof signalSubType === "undefined") {
        return false;
    }

    if (ECOMMERCE_CHANGE_SUBTYPES.has(signalSubType)) {
        const change = (filters as EcommerceSignalFilters).change;

        return typeof change?.metric !== "undefined" && change.direction != null && change.period != null;
    }

    if (
        signalSubType === EcommerceSignalSubType.OnlineRevenueReached ||
        signalSubType === EcommerceSignalSubType.OnlineTransactionsReached
    ) {
        const bucketTransition = (filters as EcommerceSignalFilters).bucketTransition;

        return typeof bucketTransition?.metric !== "undefined" && typeof bucketTransition?.bucket === "string";
    }

    return false;
};
